import styled from 'styled-components'

export const WarningBanner = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-start;
  width: 100%;
  padding: 8px;
  border: 1px solid #ffeaa3;
  border-radius: 8px;
  background: #fff9e3;

  svg {
    flex-shrink: 0;
    width: 14px;
    height: 14px;
    margin: 4px;
    font-size: 14px;
    color: #d48806;
  }
`

export const WarningContent = styled.div`
  flex: 1;
  min-width: 0;
`

export const WarningText = styled.p`
  margin: 0;
  color: #363636;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  word-break: break-word;
`
